import dayjs from "dayjs";

// ─── Constants shared by the task board, cards and dialogs ───

export const ALL_STATUSES = ["Pending", "In Progress", "Completed", "Finished"];

// antd Tag presets, so priority/status colors follow the theme instead of hardcoded hex.
export const PRIORITY_TAG = {
  High: "error",
  Medium: "warning",
  Low: "success"
};

export const STATUS_TAG = {
  Pending: "processing",
  "In Progress": "warning",
  Completed: "success",
  Finished: "default"
};

// startDate/endDate are stored as arrays of dates; older tasks may hold a plain value or nothing.
export const firstDate = value => (Array.isArray(value) ? value.find(Boolean) : value) || null;

export const formatTaskDate = (value, format = "DD MMM YYYY") => {
  const date = firstDate(value);
  return date && dayjs(date).isValid() ? dayjs(date).format(format) : "—";
};
